module.exports = __webpack_public_path__ + "static/media/landing-mngr.38acdca9.svg";